import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=89c22e80"
import script from "./Accueil.vue?vue&type=script&lang=js"
export * from "./Accueil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89c22e80')) {
      api.createRecord('89c22e80', component.options)
    } else {
      api.reload('89c22e80', component.options)
    }
    module.hot.accept("./Accueil.vue?vue&type=template&id=89c22e80", function () {
      api.rerender('89c22e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Accueil.vue"
export default component.exports